var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-whitish text-secondary py-6 flex justify-between"},[_c('div',[_c('h1',{staticClass:"font-bold text-2xl"},[_vm._v(_vm._s(this.title))])]),_c('div',[_c('Button',{attrs:{"label":"New Campaign"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }